/**
 * API Configuration
 * Centralized API URL and endpoint definitions
 */

export const API_BASE_URL: string = import.meta.env.VITE_API_URL || '';

export const API_ENDPOINTS = {
  // Auth
  AUTH_REGISTER: '/api/auth/register',
  AUTH_LOGIN: '/api/auth/login',
  AUTH_REFRESH: '/api/auth/refresh',
  AUTH_LOGOUT: '/api/auth/logout',
  AUTH_ME: '/api/auth/me',
  AUTH_PREFERENCES: '/api/auth/preferences',
  AUTH_ANALYSIS_CONFIG: '/api/auth/analysis-config',
  AUTH_BANNED_PLAYERS: '/api/auth/banned-players',
  AUTH_VERIFY_EMAIL: '/api/auth/verify-email',
  AUTH_RESEND_VERIFICATION: '/api/auth/resend-verification',

  // Legs
  LEGS: '/api/legs',

  // Parlays
  PARLAYS: '/api/parlays',
  PARLAYS_TRACK: '/api/parlays/track',
  PARLAYS_ANALYZE: '/api/parlays/analyze-ai',

  // Bets
  BETS: '/api/bets',

  // Games
  GAMES: '/api/games',
  PLAYERS_ALL: '/api/players/all',
  PLAYER_IDS: '/api/players/ids',
  PROPS: '/api/props',

  // Picks
  PICKS: '/api/picks',
  PICKS_STREAM: '/api/picks/stream',
  PICKS_CANCEL: '/api/picks/cancel',

  // Generations (network recovery + cold-start detection)
  GENERATIONS_UNDELIVERED: '/api/generations/undelivered',
  GENERATIONS_CONFIRM: '/api/generations/confirm',
  GENERATIONS_ACTIVE: '/api/generations/active',

  // Settlement
  SETTLEMENT_RUN: '/api/settlement/run',
  SETTLEMENT_STATUS: '/api/settlement/status',

  // Scoring
  SCORING_CALIBRATION: '/api/scoring/calibration',

  // Subscription
  SUBSCRIPTION_CHECKOUT: '/api/subscription/checkout',
  SUBSCRIPTION_PORTAL: '/api/subscription/portal',
  SUBSCRIPTION_STATUS: '/api/subscription/status',

  // Creator
  CREATOR_STATUS: '/api/creator/status',
  CREATOR_EARNINGS: '/api/creator/earnings',
  CREATOR_FOLLOWERS: '/api/creator/followers',

  // Config
  CONFIG_FEATURES: '/api/config/features',
  CONFIG_VERSION: '/api/config/version',

  // Health
  HEALTH: '/api/health',
} as const;

export type ApiEndpoint = (typeof API_ENDPOINTS)[keyof typeof API_ENDPOINTS];

/**
 * Build full API URL
 */
export function apiUrl(endpoint: string): string {
  return `${API_BASE_URL}${endpoint}`;
}
